import { render, staticRenderFns } from "./Ecology.vue?vue&type=template&id=8e72e9e4&scoped=true&"
import script from "./Ecology.vue?vue&type=script&lang=ts&"
export * from "./Ecology.vue?vue&type=script&lang=ts&"
import style0 from "./Ecology.vue?vue&type=style&index=0&id=8e72e9e4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e72e9e4",
  null
  
)

export default component.exports